// ToDo: delete enum: temporary - types getting from server
export enum KnmTypeCodesEnum {
  KZ = 'KZ',
  PP = 'PP',
  VP = 'VP',
  PP248P294 = 'PP248P294',
}
